export default __webpack_public_path__ + "static/media/applications-image-05.a73326b4.jpg";